import { Autocomplete, FormControl, TextField, Typography } from "@mui/material";
import { classes } from "../classes";
import { useContext } from "react";

export default function Neighborhood({ context }) {
    
    const {
        neighborhood, setNeighborhood, 
        neighborhoodsList
    } = useContext(context); 
    
    return (
        <>
            <Typography style={classes.labelInput}>
                Bairro:
            </Typography>
            <FormControl variant="outlined" style={classes.formControl}>
                <Autocomplete
                    value={neighborhood}
                   
                    onChange={(e, newValue) => setNeighborhood(newValue)} 
                    onBlur={() => setNeighborhood(prev => prev || { name: 'Todos' })}
                    isOptionEqualToValue={(a, b) => a.name === b.name}
                    disableClearable={true}
                    id="Bairro"
                    options={neighborhoodsList}
                    getOptionLabel={(option) => option.name}
                    defaultValue={{ name: 'Todos' }}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                />
            </FormControl>
        </>
    )
}